import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-331dab5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "record"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]

import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useIp, useInfo } from '@/store';
import { onBeforeRouteLeave } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'Record',
  setup(__props) {

_useCssVars(_ctx => ({
  "357a9a76": (_unref(bg).pc),
  "472a7c74": (_unref(bg).mobile),
  "7704f62e": (_unref(volumes).pc[0]),
  "7704f5f0": (_unref(volumes).pc[1]),
  "7704f5b2": (_unref(volumes).pc[2]),
  "7704f574": (_unref(volumes).pc[3]),
  "7704f536": (_unref(volumes).pc[4]),
  "7704f4f8": (_unref(volumes).pc[5]),
  "7704f4ba": (_unref(volumes).pc[6]),
  "7704f47c": (_unref(volumes).pc[7]),
  "f57b944c": (_unref(volumes).mobile[0]),
  "f57b940e": (_unref(volumes).mobile[1]),
  "f57b93d0": (_unref(volumes).mobile[2]),
  "f57b9392": (_unref(volumes).mobile[3]),
  "f57b9354": (_unref(volumes).mobile[4]),
  "f57b9316": (_unref(volumes).mobile[5]),
  "f57b92d8": (_unref(volumes).mobile[6]),
  "f57b929a": (_unref(volumes).mobile[7]),
  "4c957f86": (_unref(signal).pc[0]),
  "4c957fa5": (_unref(signal).pc[1]),
  "4c957fc4": (_unref(signal).pc[2]),
  "4c957fe3": (_unref(signal).pc[3]),
  "4c958002": (_unref(signal).pc[4]),
  "4c958021": (_unref(signal).pc[5]),
  "4c958040": (_unref(signal).pc[6]),
  "4c95805f": (_unref(signal).pc[7]),
  "151ccc12": (_unref(signal).mobile[0]),
  "151ccbd4": (_unref(signal).mobile[1]),
  "151ccb96": (_unref(signal).mobile[2]),
  "151ccb58": (_unref(signal).mobile[3]),
  "151ccb1a": (_unref(signal).mobile[4]),
  "151ccadc": (_unref(signal).mobile[5]),
  "151cca9e": (_unref(signal).mobile[6]),
  "151cca60": (_unref(signal).mobile[7]),
  "a74af218": (_unref(musicTel).pc),
  "4ee4442e": (_unref(musicBg).pc),
  "0d399d46": (_unref(musicBg).mobile),
  "34c92188": (_unref(musicBgActive).pc),
  "59577ac3": (_unref(musicCircle).pc),
  "d901d51c": (_unref(musicCircle).mobile),
  "46919b81": (_unref(figureBg).pc),
  "211ea730": (_unref(figureBg).mobile)
}))

const { record } = storeToRefs(useIp());
const audio = new Audio(record.value.audio);
const state = ref(false);
function play() {
  if (audio.paused) {
    audio.play();
    state.value = true;
  } else {
    audio.pause();
    state.value = false;
  }
}
audio.addEventListener('ended', function () {
  state.value = false;
});
onBeforeRouteLeave(() => {
  if (!audio.paused) {
    audio.pause();
  }
});
const { getImg } = useInfo();
const bg = computed(() => ({
  pc: `url(${getImg('ip_pc_record_bg')})`,
  mobile: `url(${getImg('ip_mobile_record_bg')})`,
}));
const volumes = computed(() => ({
  pc: [
    `url(${getImg('ip_pc_volume_1')})`,
    `url(${getImg('ip_pc_volume_2')})`,
    `url(${getImg('ip_pc_volume_3')})`,
    `url(${getImg('ip_pc_volume_4')})`,
    `url(${getImg('ip_pc_volume_5')})`,
    `url(${getImg('ip_pc_volume_6')})`,
    `url(${getImg('ip_pc_volume_7')})`,
    `url(${getImg('ip_pc_volume_8')})`,
  ],
  mobile: [
    `url(${getImg('ip_mobile_volume_1')})`,
    `url(${getImg('ip_mobile_volume_2')})`,
    `url(${getImg('ip_mobile_volume_3')})`,
    `url(${getImg('ip_mobile_volume_4')})`,
    `url(${getImg('ip_mobile_volume_5')})`,
    `url(${getImg('ip_mobile_volume_6')})`,
    `url(${getImg('ip_mobile_volume_7')})`,
    `url(${getImg('ip_mobile_volume_8')})`,
  ],
}));
const signal = computed(() => ({
  pc: [
    `url(${getImg('ip_pc_signal_1')})`,
    `url(${getImg('ip_pc_signal_2')})`,
    `url(${getImg('ip_pc_signal_3')})`,
    `url(${getImg('ip_pc_signal_4')})`,
    `url(${getImg('ip_pc_signal_5')})`,
    `url(${getImg('ip_pc_signal_6')})`,
    `url(${getImg('ip_pc_signal_7')})`,
  ],
  mobile: [
    `url(${getImg('ip_mobile_signal_1')})`,
    `url(${getImg('ip_mobile_signal_2')})`,
    `url(${getImg('ip_mobile_signal_3')})`,
    `url(${getImg('ip_mobile_signal_4')})`,
    `url(${getImg('ip_mobile_signal_5')})`,
    `url(${getImg('ip_mobile_signal_6')})`,
    `url(${getImg('ip_mobile_signal_7')})`,
  ],
}));
const musicTel = computed(() => ({
  pc: `url(${getImg('ip_pc_music_tel')})`,
}));
const musicBg = computed(() => ({
  pc: `url(${getImg('ip_pc_music_bg')})`,
  mobile: `url(${getImg('ip_mobile_music_bg')})`,
}));
const musicBgActive = computed(() => ({
  pc: `url(${getImg('ip_pc_music_bg_active')})`,
}));
const musicCircle = computed(() => ({
  pc: `url(${getImg('ip_pc_music_circle')})`,
  mobile: `url(${getImg('ip_mobile_music_circle')})`,
}));
const figureBg = computed(() => ({
  pc: `url(${getImg('ip_pc_figure_bg')})`,
  mobile: `url(${getImg('ip_mobile_figure_bg')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(record))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "kv",
            src: _unref(record).kvImage,
            alt: ""
          }, null, 8, _hoisted_3),
          _createElementVNode("div", {
            class: "title",
            innerHTML: _unref(record).text
          }, null, 8, _hoisted_4),
          _createElementVNode("button", {
            type: "button",
            onClick: play,
            class: _normalizeClass(['music', { playing: state.value }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['tel', { playing: state.value }])
            }, null, 2)
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})